import { Answer, Question } from 'shared/api/requests/questionnaire/schemas'

export const createAnswers = (questions: Question[]): Answer[] => {
  return questions.map((question) => ({
    question_id: question.id,
    question_type: question.type,
    answers: [],
  }))
}
